import { render, staticRenderFns } from "./QuestionariCompilati.vue?vue&type=template&id=13f1f5cd&"
import script from "./QuestionariCompilati.vue?vue&type=script&lang=js&"
export * from "./QuestionariCompilati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports